import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import stylesPay from './WpTurnIndex.module.less';

import WpTurnLimit5 from './WpTurnLimit5';
import WpTurnStart from './WpTurnStart';
import WpTurnStop from './WpTurnStop';
import WpOrder from './WpOrder';

import { getWpOrderSkuList } from '../../actions/wallpaper';
import { logging } from '../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectWallpaper = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const { wpShowOrder, wpShowTurnStart, wpShowTurnStop, wpShowTurnLimit } = useSelector(
    selectWallpaper,
  );

  return (
    <>
      {wpShowTurnStart?.show && <WpTurnStart></WpTurnStart>}
      {wpShowTurnStop?.show && <WpTurnStop></WpTurnStop>}
      {wpShowTurnLimit?.show && <WpTurnLimit5></WpTurnLimit5>}
      {wpShowOrder?.show && <WpOrder></WpOrder>}
    </>
  );
});
